import jQuery from "jquery";
import ModalVideo from "modal-video";

jQuery(function ($) {
  $("body").removeClass("no-js");

  //init youtube modales
  new ModalVideo(".js-modal-btn", {
    youtube: {
      autoplay: 1,
      nocookie: "true",
    },
  });
});
